// @catalog F.010
/**
 * usePolicyDefaults — defaults del flujo de compras que viven en
 * `distribution_policies` y gobiernan controles del dialog de forecast:
 *
 *   - `purchase_horizon_months` → horizonte default (B4.1, F5-B1): NO un 2
 *     hardcoded; el usuario lo ajusta en la toolbar por sesión.
 *   - `purchase_growth_pct` → default del campo "Crecimiento proyectado"
 *     (2026-06-10): 0 = sin crecimiento; ajustable por sesión en el dialog.
 *
 * Cambiar la policy cambia el default; la sesión nunca escribe la policy.
 */
import { useEffect, useState } from "react";

import { distributionService } from "../../services/distributionService";

export function usePolicyDefaults(): {
  forecastMonths: number;
  setForecastMonths: React.Dispatch<React.SetStateAction<number>>;
  defaultGrowthPct: number;
} {
  const [forecastMonths, setForecastMonths] = useState(2);
  const [defaultGrowthPct, setDefaultGrowthPct] = useState(0);

  useEffect(() => {
    let active = true;
    distributionService
      .getDistributionPolicies()
      .then((snap) => {
        const months = Number(snap.global["purchase_horizon_months"]);
        if (active && Number.isFinite(months) && months >= 1) {
          setForecastMonths(months);
        }
        const growth = Number(snap.global["purchase_growth_pct"]);
        if (active && Number.isFinite(growth) && growth >= 0) {
          setDefaultGrowthPct(Math.min(100, growth));
        }
      })
      .catch((err) => {
        console.warn(
          "No se pudo cargar purchase_horizon_months / purchase_growth_pct de la policy:",
          err,
        );
      });
    return () => {
      active = false;
    };
  }, []);

  return { forecastMonths, setForecastMonths, defaultGrowthPct };
}
